import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { PrimaryButton, Input } from "../components/ui-bits";
import { ShippingContainerIcon, KeyIcon } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ChangePasswordPage() {
  const { user, changePassword, logout } = useAuth();
  const navigate = useNavigate();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("New passwords don't match");
      return;
    }
    if (next.length < 8) {
      toast.error("Min 8 characters");
      return;
    }
    setLoading(true);
    try {
      await changePassword(cur, next);
      toast.success("Password changed");
      navigate("/", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    } finally {
      setLoading(false);
    }
  };

  const forced = user?.must_change_password;

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md border border-zinc-200 bg-white p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 bg-zinc-950 text-white flex items-center justify-center">
            <ShippingContainerIcon size={26} weight="bold" />
          </div>
          <div>
            <div className="font-heading font-black text-xl tracking-tight">CARGO/SCAN</div>
            <div className="overline mt-0.5">{forced ? "Set a new password" : "Change password"}</div>
          </div>
        </div>

        {forced && (
          <div className="text-xs text-amber-900 bg-amber-50 border border-amber-200 p-3 mb-5 flex gap-2">
            <KeyIcon size={16} className="flex-shrink-0 mt-0.5" />
            <div>You signed in with a one-time PUK. Set a new password to continue.</div>
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <label className="block text-xs text-zinc-500 mb-1">{forced ? "PUK / temporary password" : "Current password"}</label>
            <Input data-testid="cp-current" type="password" value={cur} onChange={(e) => setCur(e.target.value)} required className="w-full" />
          </div>
          <div>
            <label className="block text-xs text-zinc-500 mb-1">New password (min 8 chars)</label>
            <Input data-testid="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={8} className="w-full" />
          </div>
          <div>
            <label className="block text-xs text-zinc-500 mb-1">Confirm new password</label>
            <Input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} className="w-full" />
          </div>
          <PrimaryButton type="submit" data-testid="cp-submit" disabled={loading} className="w-full">
            {loading ? "Saving…" : "Change password"}
          </PrimaryButton>
        </form>

        {forced && (
          <button
            type="button"
            onClick={() => { logout(); navigate("/login"); }}
            className="mt-4 text-xs text-zinc-500 hover:text-zinc-950"
          >
            Cancel and sign out
          </button>
        )}
      </div>
    </div>
  );
}
